import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function FifthDimensionModal({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[9996] flex items-center justify-center px-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="fifth-dimension-modal"
        >
          <div className="absolute inset-0 bg-black/85 backdrop-blur-md" onClick={onClose} />
          <motion.div
            className="relative z-10 max-w-lg w-full border border-white/10 bg-[#080808] p-10 md:p-14 text-center"
            initial={{ opacity: 0, y: 30, filter: "blur(8px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <button
              onClick={onClose}
              className="absolute top-5 right-5 text-white/40 hover:text-gold transition-colors"
              data-testid="fifth-modal-close"
              aria-label="Close"
            >
              <X size={20} />
            </button>

            <p className="font-mono text-[10px] tracking-[0.4em] text-red-600 mb-8">05 — ACCESS RESTRICTED</p>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight text-white mb-8">
              The Fifth Dimension<br />cannot be streamed.
            </h2>
            <div className="gold-line w-24 mx-auto mb-8" />
            <p className="font-mono text-[11px] tracking-[0.3em] text-white/50">ACCESS METHOD: UNKNOWN</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
